import { render, staticRenderFns } from "./ChangeLog.vue?vue&type=template&id=25bcabe7"
import script from "./ChangeLog.vue?vue&type=script&lang=js"
export * from "./ChangeLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports